// Constants
export const descuentos_referido = () => {
  return {
    descuentos_referido: {      
      id: {
        namepath: ['afiliacion_nueva','afiliado_crear','afiliacion_pendientes','informes_afiliaciones','afiliado_ficha'],
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        datatype: 
        {
          predeterminate: null
        }
      },
      id_datos_afiliado: {
        namepath: ['afiliacion_nueva','afiliado_crear','afiliacion_pendientes','informes_afiliaciones','afiliado_ficha'],
        type: 'text',
        label: 'Nombre del referidor',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      }, 
      id_info_afiliacion: {
        namepath: ['afiliacion_nueva','afiliado_crear','afiliacion_pendientes','informes_afiliaciones','afiliado_ficha'],
        type: 'text',
        label: 'Nombre del referidor',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      }, 
      referido: {
        type: 'json',
        label: 'Referido',
        namepath: ['afiliacion_nueva','afiliado_crear','afiliacion_pendientes','informes_afiliaciones','afiliado_ficha'],
        placeholder: '',
        description: 'correo electonico',
        validate: '',
        datatype: 
        {
          type: 'json',
          predeterminate: {},
        }
      }, 
      descuento: {
        namepath: ['afiliacion_nueva','afiliado_crear','afiliacion_pendientes','informes_afiliaciones','aportes_registrar','afiliado_ficha'],
        type: 'number',
        label: 'Descuento',
        placeholder: '',
        description: 'Descuento', 
        validate: '',
        datatype: { 
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }   
      }, 
      nota_delete: {
        namepath: ['aportes_registrar'],
        type: 'text',
        label: 'Descuento',
        placeholder: '',
        description: 'Descuento', 
        validate: '',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      }, 
      deleted_at: {
        namepath: ['aportes_registrar'],
        type: 'text',
        label: 'Descuento',
        placeholder: '',
        description: 'Descuento', 
        validate: '',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      }, 
    }
  }
}
